
import { Vue, Component } from 'vue-property-decorator';
import { fetchNewslist } from '../api/index';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);
@Component
export default class Home extends Vue {
  vector1: string = require('../assets/vector1.png');
  vector2: string = require('../assets/vector2.png');
  vector3: string = require('../assets/vector3.png');
  message: any[] = [];
  interview: any[] = [];
  brand: any[] = [];
  major: any[] = [];
  a: number = 0;
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  classId: number = 9070;
  // beforeRouteLeave(to: any, from: any, next: any) {
  //   console.log(1111);
  // }
  mounted() {
    this.onLoad();
  }
  goDetail(a: any) {
    window.location.href = a;
  }
  onLoad() {
    fetchNewslist(this.page, this.classId, '信息速递').then((res: any) => {
      this.message = res.data.data[0].list ? res.data.data[0].list.splice(0, 3) : [];
    });
    fetchNewslist(this.page, this.classId, '招办访谈').then((res: any) => {
      this.interview = res.data.data[0].list ? res.data.data[0].list.splice(0, 3) : [];
    });
    fetchNewslist(this.page, this.classId, '热门专业').then((res: any) => {
      this.brand = res.data.data[0].list ? res.data.data[0].list.splice(0, 4) : [];
    });
    fetchNewslist(this.page, this.classId, '品牌院校').then((res: any) => {
      this.major = res.data.data[0].list ? res.data.data[0].list.splice(0, 3) : [];
    });
  }
  toScroll(ele: string) {
    if (ele === 'message') {
      this.a = (this.$refs.message as Element).getBoundingClientRect().top;
    } else if (ele === 'interview') {
      this.a = (this.$refs.interview as Element).getBoundingClientRect().top;
    } else if (ele === 'brand') {
      this.a = (this.$refs.brand as Element).getBoundingClientRect().top;
    } else if (ele === 'major') {
      this.a = (this.$refs.major as Element).getBoundingClientRect().top;
    }
    this.scrollTop();
  }
  scrollTop() {
    document.documentElement.scrollTop = this.a;
    document.body.scrollTop = this.a;
  }
  toDetail(path: string) {
    this.$router.push(`${path}`);
  }
}
